module.exports = __webpack_public_path__ + "static/img/enter_banner_iphone.2525f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enter_banner_iphone.png
// module id = 2Sxe
// module chunks = 1